// Add extra product to cart when main product is added
// document.addEventListener("DOMContentLoaded", function () {
//   const extraVariantId = 51570499354938;

//   // Generate a unique ID to link main and extra products in cart
//   const cartBundleId = Date.now().toString();

//   const form = document.getElementById("product-form-template--25097070870842__main");
//   if (!form) {
//     console.warn("Product form not found.");
//     return;
//   }

//   form.addEventListener("submit", async function (e) {
//     e.preventDefault();

//     const nameInput = document.getElementById("personalise_initial_input");
//     const secondLineInput = document.getElementById("personalise_initial_input2");

//     const personalization1 = nameInput?.value?.trim();
//     const personalization2 = secondLineInput?.value?.trim();
//     const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || "1");

//     const variantIdInput = form.querySelector('[name="id"]');
//     const mainVariantId = parseInt(variantIdInput?.value);

//     if (!mainVariantId) {
//       console.error("Main variant ID not found.");
//       return;
//     }

//     const formData = new FormData(form);
//     formData.append("properties[cart_bundle_id]", cartBundleId);

//     try {
//       // Add main product
//       const resMain = await fetch("/cart/add.js", {
//         method: "POST",
//         body: formData,
//       });

//       if (!resMain.ok) {
//         console.error("Failed to add main product");
//         return;
//       }

//       const mainProductData = await resMain.json();
//       console.log("Main product added:", mainProductData);

//       // Add extra product only if personalized
//       if (personalization1 || personalization2) {
//         const resExtra = await fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             id: extraVariantId,
//             quantity: quantity,
//             properties: {
//               _linked_to_main_product: true,
//               cart_bundle_id: cartBundleId,
//               linked_main_variant: mainVariantId,
//             },
//           }),
//         });

//         if (!resExtra.ok) {
//           console.error("Failed to add extra product");
//           return;
//         }

//         console.log("Extra product added");
//         document.dispatchEvent(new CustomEvent("cart:refresh"));
//       } else {
//         console.log("No personalization — extra product not added");
//       }

//       // ✅ Refresh cart drawer after adding products
//       const cartRes = await fetch("/cart.js");
//       const cartData = await cartRes.json();
//       console.log("Cart updated:", cartData);

//       // Dispatch event — many themes like Dawn listen for this to update cart drawer
//       document.dispatchEvent(new CustomEvent("cart:updated", { detail: cartData }));
//       document.dispatchEvent(new CustomEvent("cart:refresh"));

//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   });

//   // Cleanup: remove extra product if main product is gone
//   async function cleanUpExtraItemIfMainRemoved() {
//     try {
//       const res = await fetch("/cart.js");
//       const cart = await res.json();

//       let mainVariantIds = new Set();
//       let extraItemKey = null;
//       let extraLinkedMainId = null;

//       for (const item of cart.items) {
//         if (item.id === extraVariantId && item.properties?._linked_to_main_product) {
//           extraItemKey = item.key;
//           extraLinkedMainId = parseInt(item.properties?.linked_main_variant);
//         } else {
//           mainVariantIds.add(item.id);
//         }
//       }

//       if (extraItemKey && extraLinkedMainId && !mainVariantIds.has(extraLinkedMainId)) {
//         await fetch("/cart/change.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             id: extraItemKey,
//             quantity: 0,
//           }),
//         });

//         console.log("Removed extra product because linked main product is not in the cart.");
//       }

//     } catch (error) {
//       console.error("Cart cleanup error:", error);
//     }
//   }

//   // Less frequent interval to reduce performance load
//   setInterval(cleanUpExtraItemIfMainRemoved, 3000);
// });































class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }


open(triggeredBy) {
  if (triggeredBy) this.setActiveElement(triggeredBy);

  this.classList.add("m-cart-drawer--active");

  requestAnimationFrame(() => {
    this.style.setProperty("--m-bg-opacity", "0.5");
    this.cartDrawerInner.style.setProperty("--translate-x", "0");
  });

}




  

// open(triggeredBy) {
//   // Refresh the cart first
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       console.log('Cart refreshed:', cart);

//       // Now proceed with original drawer open logic
//       if (triggeredBy) this.setActiveElement(triggeredBy);
//       this.classList.add("m-cart-drawer--active");

//       requestAnimationFrame(() => {
//         this.style.setProperty("--m-bg-opacity", "0.5");
//         this.cartDrawerInner.style.setProperty("--translate-x", "0");
//       });

//       window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
//       document.documentElement.classList.add("prevent-scroll");

//       // Optional: update cart UI here with `cart.items`
//     })
//     .catch(err => {
//       console.error('Failed to refresh cart:', err);

//       // Even if cart refresh fails, open the drawer as fallback
//       if (triggeredBy) this.setActiveElement(triggeredBy);
//       this.classList.add("m-cart-drawer--active");

//       requestAnimationFrame(() => {
//         this.style.setProperty("--m-bg-opacity", "0.5");
//         this.cartDrawerInner.style.setProperty("--translate-x", "0");
//       });

//       window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
//       document.documentElement.classList.add("prevent-scroll");
//     });
// }



  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          if (section.block === "cart-items") {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
    this.getCart().then((cart) => {
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
        block: "cart-footer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);









